const SvgIconRadioUnchecked = props => (
	<svg viewBox="0 0 20 20" {...props}>
		<circle cx={10} cy={10} r={9.43} fill="#fff" stroke="currentColor" strokeMiterlimit={10} />
	</svg>
);

export default SvgIconRadioUnchecked;
